import { forwardRef } from 'preact/compat'

export const SearchInput = forwardRef(({ onInput, redirect }, ref) => {
  return (
    <input
      ref={ref}
      onInput={onInput}
      className="grow field-input w-full h6 font-medium p-0 border-0 focus:border-0"
      type="text"
      name="query"
      placeholder="Search"
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          if (redirect) {
            window.location.href = redirect
          } else {
            window.location.href = `/search?query=${e.target.value}`
          }
        }
      }}
    />
  )
})
